document.addEventListener("DOMContentLoaded", function () {
	const shieldsCarousel = document.querySelector(".shields-carousel__swiper");

	if (shieldsCarousel) {
		const displayValue = getComputedStyle(shieldsCarousel, null).display;

		if (displayValue == "block") {
			const swiper = new Swiper(".shields-carousel__swiper", {
				// Optional parameters
				direction: "horizontal",
				loop: true,
				effect: "slide",
				// autoplay: { delay: 5000 },
				speed: 1000,
				autoHeight: true,
				keyboard: true,
				centeredSlides: true,
				spaceBetween: 15,
				grabCursor: false,
				breakpoints: {
					475: {
						slidesPerView: 1.75,
					},
					375: {
						slidesPerView: 1.25,
					},
				},
	
				// If we need pagination
				pagination: {
					el: ".swiper-pagination",
				},
	
				// Navigation arrows
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			});
		}
	}


});
